import { preferedLanguage } from '../../components/LanguageSwitcher/PreferedLanguage';
import { normalizeLocale } from '../helpers/constants.helpers';

/**
 * Maps canonical UI/i18next locales to the lowercase API locale values.
 */
const API_LANGUAGE_MAPPINGS = Object.freeze({
  'zh-Hans': 'zh-hans',
  'zh-Hant': 'zh-hant',
  'pt-BR': 'pt-br',
});

/**
 * Returns the language value expected by the API.
 *
 * @param {string} language
 * @returns {string}
 */
export function getApiLanguage(language = preferedLanguage()) {
  const canonicalLanguage = normalizeLocale(language);

  return API_LANGUAGE_MAPPINGS[canonicalLanguage] || canonicalLanguage;
}
